import { QueryClient } from '@tanstack/react-query';

const isRateLimitedError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const status = (error as { status?: number; response?: { status?: number } }).status
    ?? (error as { response?: { status?: number } }).response?.status;
  if (status === 429) {
    return true;
  }
  const message = String((error as { message?: string }).message || '').toLowerCase();
  return message.includes('too many requests') || message.includes('rate limit');
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Profile/stats/dashboard reads change infrequently relative to navigation.
      staleTime: 2 * 60_000,
      gcTime: 10 * 60_000,
      // Never retry 429 — retries amplify rate-limit storms.
      retry: (failureCount, error) => {
        if (isRateLimitedError(error)) {
          return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});
